// 通过该文件获取异步数据
import { getuser, outlogin } from '../api/login.js'
import { Message } from 'element-ui'
import { removeToken } from '@/utils/auth.js'
import { removeStore, setStore } from '@/utils/storage.js'
import { teacher, student, constantRoutes } from '@/router'
export default {
  // 退出登录
  LOG_OUT(store) {
    return new Promise((resolve, reject) => {
      outlogin()
        .then(() => {
          removeStore('OcUserInfo')
          removeStore('routerlist')
          removeToken()
          store.commit('removerouterlist')
          resolve()
          Message.success('退出成功！')
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 动态路由
  generateRoutes(store) {
    return new Promise((resolve) => {
      let accessedRoutes
      if (store.state.classinfo.sysUser.userIsteacher == 1) {
        //管理员则不需按权限列表过滤
        accessedRoutes = [...teacher]
      } else {
        accessedRoutes = [...student]
      }
      store.commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  // 记录用户信息
  SET_USER: (store) => {
    return new Promise(async (resolve) => {
      const res = await getuser()
      const {
        userid,
        username,
        sysUser: {
          sex,
          status,
          phonenumber,
          avatar,
          nickName,
          userIsteacher,
          userIntroduction,
        },
      } = res.data
      // 解构出有用的数据
      const needInfo = {
        userid,
        username,
        sysUser: {
          sex,
          status,
          phonenumber,
          avatar,
          nickName,
          userIsteacher,
          userIntroduction,
        },
      }
      store.commit('SET_USERS', needInfo)
      resolve(needInfo)
    })
  },
}
